import { parse as parseUrl } from './url';

export default parseUrl;
